<template>
  <div class="field-input" :class="{ 'has-error': $validator.errors.has(name, validateScope) }">
    <el-input type="textarea" v-model="internalValue" :disabled="disabled === true" :placeholder="placeholder"
              :name="name" v-validate="validate" :data-vv-as="validateLabel"
              :autosize="{minRows: minRows, maxRows: maxRows}" resize="none"></el-input>
    <span class="error-message"><strong>{{$validator.errors.first(name, validateScope)}}</strong></span>
  </div>
</template>

<script lang="js">

export default {
  name: 'FieldTextAreaCmp',
  components: {},
  props: {
    value: null,
    name: '',
    placeholder: null,
    validate: null,
    validateLabel: '',
    validateScope: null,
    disabled: {type: Boolean, default: false},
    minRows: {type: Number, default: 7},
    maxRows: {type: Number, default: 7}
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  data () {
    return {
      internalValue: this.value
    }
  },
  watch: {
    value (newValue) {
      this.internalValue = newValue
    },
    internalValue (newValue) {
      this.$emit('input', newValue)
    }
  }
}

</script>
<style scoped>
  .field-input {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/field/textarea.vue